import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService implements OnDestroy {
  public isTableOperationsEventCalled = new Subject<{
    event: string;
    data: any;
  }>();
  public filterChangedEvent = new EventEmitter<any>();
  public filterChanged = new EventEmitter<any>();
  public sortChangedEvent = new EventEmitter<any>();
  public sortChanged = new EventEmitter<any>();


  public showTableLoader() {
    this.isTableOperationsEventCalled.next({ event: 'showLoader', data: null });
  }

  public HideTableLoader() {
    this.isTableOperationsEventCalled.next({ event: 'hideLoader', data: null });
  }

  public ShowNoRowsOverlay() {
    this.isTableOperationsEventCalled.next({ event: 'showNoRows', data: null });
  }

  public changeFilter(event: any) {
    this.filterChangedEvent.emit(event);
  }

  public onFilterChange(event: any){
    
    this.filterChanged.emit(event);
  }
  public changeSort(event: any) {
    this.sortChangedEvent.emit(event);
  }

  public onSortChange(event: any) {
    this.sortChanged.emit(event);
  }
  public DownloadAsExcel(title: string) {
    this.isTableOperationsEventCalled.next({ event: 'downloadExcel', data: title });
  }
  public searchValueSubject = new Subject<string>();
  
  ngOnDestroy() {
    this.isTableOperationsEventCalled.complete();
  }
}
